import { t } from 'i18next'
import { List } from 'immutable'
import React from 'react'
import { loadedAsyncState } from 'widgets-for-react'
import { ImageContainer } from '../../cms/blocks/widgets/ImageContainer.gen'
import { getLangFromUrl } from '../utils/history.mod'
import { getDepartment } from '../vacancies/utils'
import { ParsedOverviewDetailItem, Tags } from './state'
import { vacancyContract, vacancyCountry, vacancyDepartment } from './utils'

export const Articles = ({ items }: { items: List<ParsedOverviewDetailItem> }) => (
  <section className="block block--grid grid--actueel grid--link grid--header container--m gutter--m inview">
    <div className="block__inner">
      <div className="block__content">
        <ul className="block__list grid">
          {items.count() > 0 ? (
            items.toArray().map((item, index) => {
              if (item.Title) {
                return (
                  <li key={index} className="grid__item">
                    <article className="grid__article">
                      <a className="grid__inner grid__link" href={item.Link.url}>
                        <div className="grid__visual container fit-object">
                          {item.Image && item.Image.count() > 0 ? (
                            ImageContainer(
                              loadedAsyncState(item.Image),
                              'medium',
                              'grid__image lazyload',
                              item.ImageAltText,
                              item.get_default_data_src,
                              item.get_default_data_srcset
                            ).run((_) => {})
                          ) : (
                            <img src="https://via.placeholder.com/350/" className="grid__image lazyload" alt="" />
                          )}
                        </div>

                        <div className="grid__content">
                          <header className="grid__header">
                            {(item.Tags.concat(item.meta || []) || []).map((t, i) => (
                              <span key={i} className="grid__label text--xs">
                                {t}
                              </span>
                            ))}
                            <div className="link--arrowed">
                              <svg className="link__icon" aria-hidden="true" width="20px" height="20px">
                                <use xlinkHref="#icon--arrow-right"></use>
                              </svg>
                              <h3 className="grid__title title--s">{item.Title || ''}</h3>
                            </div>
                          </header>
                          <p className="grid__intro text--s" dangerouslySetInnerHTML={{ __html: item.Description }} />
                        </div>
                        {/* <div>{item.meta && item.meta.map(meta => (<span>{meta}</span>))}</div>
          <div>{item.Description && <div dangerouslySetInnerHTML={{ __html: item.Description }} />}</div> */}
                      </a>
                    </article>
                  </li>
                )
              }
            })
          ) : (
            <p>Geen resultaten gevonden.</p>
          )}
        </ul>
      </div>
    </div>
  </section>
)

export const Vacancies = ({
  selected_tags,
  update_tags,
  items,
  items_count
}: {
  selected_tags: Tags
  update_tags: (tags: Tags, searchQuery: string) => void
  items: List<ParsedOverviewDetailItem>
  items_count: number
}) => (
  <section className="vacancies">
    <div className="vacancies__inner container container--m grid--gutter">
      <header className="vacancies__header">
        <h2 className="vacancies__title title--s">
          {' '}
          {items_count} {t('search:jobs_found')}
        </h2>
      </header>

      <div className="tags">
        <ul className="tags__list">
          {selected_tags
            .map((values, key) =>
              values.map((y) => (
                <li className="tags__item">
                  <button
                    className="tag"
                    onClick={(_) =>
                      update_tags(
                        selected_tags.set(
                          key,
                          values.filter((value1) => value1 != y)
                        ),
                        undefined
                      )
                    }
                  >
                    <span className="tag__copy">
                      {key == vacancyCountry
                        ? t(
                            `search:tag_countryname:${y
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )
                        : key == vacancyContract
                        ? t(
                            `search:tag_${y
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )
                        : key == vacancyDepartment
                        ? t(
                            `search:tag_${y
                              .replace('&', '_')
                              .replace(',', '_')
                              .replace('-', '_')
                              .split(/\s/)
                              .join('')
                              .toLowerCase()}`
                          )
                        : y}
                    </span>
                    <svg className="tag__remove" aria-hidden="true" width="12px" height="12px">
                      <use xlinkHref="#icon--cross" />
                    </svg>
                  </button>
                </li>
              ))
            )
            .valueSeq()
            .toArray()}
        </ul>
      </div>
      {items.count() > 0 ? (
        <ul className="vacancies__list">
          {items.toArray().map((item, index) => {
            if (item.Title) return <Vacancy key={index} {...item} />
          })}
        </ul>
      ) : (
        <div className="text--styled">
          <p> {t('search:no_results')}</p>
        </div>
      )}
    </div>
  </section>
)

const Vacancy = ({ Link, Title, Tags }: ParsedOverviewDetailItem): JSX.Element => (
  <li className="vacancy">
    <article className="vacancy__inner">
      <a href={`/${getLangFromUrl()}${Link.url}`} className="vacancy__link">
        <header className="vacancy__header">
          <h3 className="vacancy__title title--xs">{Title}</h3>
          <span className="vacancy__icon" />
        </header>

        <ul className="info__list">
          <JobInfoItem title={Tags[0]} icon="pin-new" width={24} height={24} />
          <JobInfoItem
            title={t(
              `search:tag_${Tags[1]
                .replace('&', '_')
                .replace(',', '_')
                .replace('-', '_')
                .split(/\s/)
                .join('')
                .toLowerCase()}`
            )}
            icon="clock-new"
            width={24}
            height={24}
          />
          <JobInfoItem
            title={t(
              `search:tag_${getDepartment(Tags[2])
                .replace('&', '_')
                .replace(',', '_')
                .replace('-', '_')
                .split(/\s/)
                .join('')
                .toLowerCase()}`
            )}
            icon="department-new"
            width={24}
            height={24}
          />
        </ul>
        <span className="vacancy__faux-link">
          <img src="/images/icons/arrow--right--orange.svg" alt="" width="24" height="24" />
          <span className="vacancy__label">{t('Vacancy:view_job_opening')}</span>
        </span>
      </a>
    </article>
  </li>
)

const JobInfoItem = ({
  title,
  icon,
  height,
  width
}: {
  title: string
  icon: string
  height: number
  width: number
}) => {
  if (title == '' || title == undefined) return
  return (
    <li className="info__item">
      <span>{title}</span>
      <svg className="info__icon" aria-hidden="true" height={height} width={width}>
        <use xlinkHref={`#icon--${icon}`} />
      </svg>
    </li>
  )
}
